import VerifyMail from './Verify'

export {
    VerifyMail,
}